export default "__VITE_ASSET__D3LWi7IF__"